// Every user-facing date goes through these (day-first); data formats stay with date-fns `format`.
import { format } from "date-fns"

export const formatWeekday = (date: Date) => format(date, "EEEE")

export const formatDayCompact = (date: Date) => format(date, "EEE d")

export const formatDayNumeric = (date: Date) => format(date, "dd/MM")

export const formatDayMonth = (date: Date) => format(date, "d MMM")

export const formatDayMonthYear = (date: Date) => format(date, "d MMM yyyy")

export const formatDayShort = (date: Date) => format(date, "EEE d MMM")

export const formatDayShortYear = (date: Date) => format(date, "EEE d MMM yyyy")

export const formatDayLong = (date: Date) => format(date, "EEEE d MMMM yyyy")

export const formatDateTimeShort = (date: Date) => format(date, "d MMM HH:mm")

export const formatDateTimeLong = (date: Date) => format(date, "EEEE d MMMM yyyy, HH:mm:ss")
